const state = {
  removedVimeoVideoIDList: [],
}

const getters = {
  removedVimeoVideoIDList: state => state.removedVimeoVideoIDList,
}

const actions = {
  insertRemovedVimeoVideoID({ commit }, data) {
    commit('insertRemovedVimeoVideoID', data)
  },
  insertRemovedVimeoVideoIDList({ commit }, data) {
    commit('insertRemovedVimeoVideoIDList', data)
  },
  resetRemovedVimeoVideoID({ commit }, data = []) {
    commit('resetRemovedVimeoVideoID', data)
  },
  removeRemovedVimeoVideoID({ commit }, data) {
    commit('removeRemovedVimeoVideoID', data)
  },
}

const mutations = {
  insertRemovedVimeoVideoID: function (state, data) {
    state.removedVimeoVideoIDList.push(data)
  },
  insertRemovedVimeoVideoIDList: function (state, data) {
    state.removedVimeoVideoIDList = state.removedVimeoVideoIDList.concat(data)
  },
  resetRemovedVimeoVideoID: function (state, data = []) {
    state.removedVimeoVideoIDList = data
  },
  removeRemovedVimeoVideoID: function (state, data) {
    const found = state.removedVimeoVideoIDList.indexOf(data);
    state.removedVimeoVideoIDList.splice(found, 1);
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
